<template>
    <div class="file-item">
        <el-link type="primary" icon="el-icon-document" :underline="false"></el-link>
        <div class="file-label" :title="label">
            {{ label }}
        </div>
        <el-link class="file-success" type="success" icon="el-icon-circle-check"
            :underline="false"
        ></el-link>
        <el-link class="file-remove" type="danger" icon="el-icon-circle-close"
            @click="handleRemove"
            :underline="false"
        ></el-link>
    </div>

</template>
<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    data() {
        return {

        }
    },
    methods: {
        handleRemove() {
            this.$emit("change", this.index)
        }
    }
}
</script>
<style lang="scss" scoped>
.file-item {
    &, & * {
        box-sizing: border-box;
    }
    &:hover {
        ::v-deep .file-remove {
            display: flex;
        }
        ::v-deep .file-success {
            display: none;
        }
    }
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .file-label {
        margin: 0 8px;
        max-width: 200px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    ::v-deep .file-remove {
        display: none;
    }
}
</style>